import React from 'react';

import { SVGComponentProps } from './svg.types';

const ImageSVG = ({ fill = '#878A92', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M12.542 0.141113H1.458C1.07122 0.141378 0.700377 0.295211 0.426978 0.568798C0.153578 0.842385 -9.08491e-08 1.21334 0 1.60011L0 10.4001C-9.08491e-08 10.7869 0.153578 11.1578 0.426978 11.4314C0.700377 11.705 1.07122 11.8588 1.458 11.8591H12.542C12.9288 11.8588 13.2996 11.705 13.573 11.4314C13.8464 11.1578 14 10.7869 14 10.4001V1.60011C14 1.21334 13.8464 0.842385 13.573 0.568798C13.2996 0.295211 12.9288 0.141378 12.542 0.141113ZM11.33 9.38511H2.73C2.6227 9.38498 2.51792 9.35264 2.4292 9.29229C2.34049 9.23194 2.27193 9.14635 2.2324 9.0466C2.19286 8.94685 2.18418 8.83754 2.20746 8.7328C2.23075 8.62806 2.28493 8.53272 2.363 8.45911L5.517 4.28011C5.61634 4.18703 5.74737 4.13523 5.8835 4.13523C6.01963 4.13523 6.15066 4.18703 6.25 4.28011L8.044 6.61511C8.14571 6.70966 8.2802 6.76095 8.41903 6.75815C8.55787 6.75536 8.69018 6.69868 8.788 6.60011L9.155 6.23311C9.2551 6.13333 9.39067 6.0773 9.532 6.0773C9.67333 6.0773 9.8089 6.13333 9.909 6.23311L11.709 8.46811C11.7851 8.54277 11.8372 8.63849 11.8586 8.74297C11.88 8.84745 11.8696 8.95593 11.8289 9.05448C11.7882 9.15304 11.7189 9.23717 11.63 9.29609C11.5411 9.355 11.4366 9.386 11.33 9.38511Z"
        fill={fill}
      />
    </svg>
  );
};

export default ImageSVG;
